import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  p {
    color: #5c5d61;
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 16px;
  }
`;

export const SelectButton = styled.button`
  border-radius: 8px;
  border: 1px solid #cdd4df;
  background: #fff;
  padding: 11px 16px;
  outline: none;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  &:hover {
    border: 1px solid rgba(120, 136, 245, 1);
  }
  p {
    color: #5c5d61;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 0;
  }
`;

export const YearMenu = styled.div`
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #7888f5;
  background: #fff;
  width: 343px;
  // max-width: 228px;
  // margin-left: 58px;
`;

export const YearOption = styled.div`
  color: #c4c4c4;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  padding: 6px 8px;
  border-bottom: 0.7px solid #e2e2e2;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.25s ease-in-out;
  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #3d3bff33;
    border-color: #3d3bff33;
    color: #000;
  }

  ${({ isActive }) => isActive && 'background: #3D3BFF33;  color: #000; '}
`;

export const QuarterMenu = styled.div`
  display: grid;
  grid-template-columns: repeat(9, minmax(0, 1fr));
  gap: 4px;
  border-radius: 8px;
  border: 1px solid #7888f5;
  background: #fff;
  padding: 6px;
  width: 100%;
  // margin-left: 58px;
`;

export const QuarterOption = styled.div`
  width: 30px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background: #fff;
  color: #c4c4c4;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  &:hover {
    background: #7888f5;
    border-color: #7888f5;
    color: #fff;
  }

  ${({ isActive }) => isActive && 'background: #7888F5; border-color: #7888F5; color: #fff;'}
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  padding-left: 8px;
  border-left: 1px solid #cdd4df;
  &:hover {
    svg {
      transform: rotate(90deg);
    }
  }
  svg {
    transition: 0.3s all ease-in-out;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(90deg)' : 'rotate(0deg)')};
  }
`;

export const Select = styled.div`
  label {
    display: block;
    color: #5c5d61;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 4px;
  }
`;

export const Items = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
`;

export const QuarterMenuWrapper = styled.div`
  margin-left: 16.7%;
`;

export const YearMenuWrapper = styled.div`
  width: 163px;
`;
